import { render, staticRenderFns } from "./ShowResult.vue?vue&type=template&id=9d456efa&"
import script from "./ShowResult.vue?vue&type=script&lang=js&"
export * from "./ShowResult.vue?vue&type=script&lang=js&"
import style0 from "./ShowResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports